import { render, staticRenderFns } from "./CustomReportPage6.vue?vue&type=template&id=04d717a7&scoped=true"
import script from "./CustomReportPage6.vue?vue&type=script&lang=js"
export * from "./CustomReportPage6.vue?vue&type=script&lang=js"
import style0 from "./CustomReportPage6.vue?vue&type=style&index=0&id=04d717a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d717a7",
  null
  
)

export default component.exports